import { useRef } from 'preact/hooks';

import FeedItem from '@/components/CommunityFeed/FeedItem';
import Loader from '@/components/Loader';
import { useOnScreenCallback } from '@/hooks';
import { useCommunityFeedInfiniteQuery } from '@/queries/community-feed';

const CommunityFeed = () => {
  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } = useCommunityFeedInfiniteQuery();
  const loadMoreDetectorRef = useRef<HTMLDivElement>(null);

  useOnScreenCallback(loadMoreDetectorRef, [0.1], (isIntersecting: boolean) => {
    if (isIntersecting && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  });

  return (
    <div className="min-h-0 grow overflow-y-auto mobile:bg-white">
      <ul className="preflight preflight-ul px-2 pb-5 pt-3 after:absolute after:inset-x-0 after:bottom-0 after:h-4 after:rounded-lg after:bg-gradient-to-t desktop:after:from-white">
        {data?.map((message) => (
          <li
            key={message.timetoken.toString()}
            className="preflight animate-in animate-out fade-in-50 fade-out empty:hidden"
          >
            <FeedItem message={message} />
          </li>
        ))}
      </ul>
      <div ref={loadMoreDetectorRef} className="min-h-4">
        {(isLoading || isFetchingNextPage) && <Loader width="40px" height="40px" className="" />}
      </div>
    </div>
  );
};

export default CommunityFeed;
